export const appNamespace = 'root';
